<template lang="pug">
.container-fluid
  vm-row(vm-w="12")
    vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
      .menu-bar
        .menu-bar-item(v-for="(item, index) in menuBarItems" :key="index" @click="select(item.index)" :class="selectedMenu === item.index ? 'selected-menu' : ''")
          vm-icon(:icon="item.icon" size="1.5rem" :color="selectedMenu === item.index ? '#D06325' : '' ")
          span(:class="selectedMenu === item.index ? 'text-menu-selected' : '' ") {{ $t(item.text) }}
  transition(name="menu-fade" mode="out-in")
    quotizations-dashboard(v-if="selectedMenu === 1")
    purchases-dashboard(v-else-if="selectedMenu === 2")
    invoices-dashboard(v-else-if="selectedMenu === 3")
</template>
<script>
const QuotizationsDashboard = () => import('@/components/dashboard/QuotizationsDashboard.vue')
const PurchasesDashboard = () => import('@/components/dashboard/PurchasesDashboard.vue')
const InvoicesDashboard = () => import('@/components/dashboard/InvoicesDashboard.vue')

export default {
  name: 'Dashboard',
  components: {
    QuotizationsDashboard,
    PurchasesDashboard,
    InvoicesDashboard
  },
  data: () => ({
    selectedMenu: 1,
    menuBarItems: [
      {
        index: 1,
        icon: 'grid-outline',
        text: 'strings.dashboard'
      },
      {
        index: 2,
        icon: 'shopping-bag-outline',
        text: 'strings.purchases'
      },
      {
        index: 3,
        icon: 'file-text-outline',
        text: 'strings.invoices'
      }
    ]
  }),
  methods: {
    select (payload) {
      this.selectedMenu = payload
    }
  }
}
</script>
<style lang="scss">

.menu-bar {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  margin-bottom: 2rem;

  .menu-bar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
}
.text-menu-selected {
  color: rgba($color: var(--primary), $alpha: 1.0);
}
.selected-menu {
  -webkit-box-shadow: 0 8px 6px -6px rgba($color: var(--primary), $alpha: 1.0);
  -moz-box-shadow: 0 8px 6px -6px rgba($color: var(--primary), $alpha: 1.0);
  box-shadow: 0 8px 6px -6px rgba($color: var(--primary), $alpha: 1.0);
}
.menu-fade-enter-active, .menu-fade-leave-active {
  transition: opacity .3s ease;
}
.menu-fade-enter, .menu-fade-leave-to
/* .menu-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.con-vm-viewer {
  z-index: 200000 !important;
}

.end {
    justify-content: end;
}

.center {
    justify-content: center;
}

.start {
    justify-content: start;
}

.space-between {
    justify-content: space-between;
}

.wrap {
    flex-wrap: wrap;
}

.items-start {
    align-items: left;
}

.column {
    flex-direction: column;
}

.flex {
    display: flex;
    align-items: center;
    gap: 5rem;
}

.gap-2 {
    gap: 2rem;
}

.gap-1 {
    gap: 1rem;
}

.gap-0 {
    gap: 0rem;
}

.margin-bottom {
    margin-bottom: 2rem;
}

.margin-left {
    margin-left: 1rem;
}

.bold {
    font-weight: bold;
}

.text-align-right {
    text-align: right;
}

.middle-width {
    width: 50%;
}

.three-quarters-width {
    width: 75%;
}

.mw-90 {
    max-width: 90%;
}

.mw-95 {
    max-width: 95%;
}

.mw-98 {
    max-width: 98%;
}

.mw-985 {
    max-width: 98.5%;
}

.apexchart_container {
    width: 100%;
    padding: 2em;
    height: 480px;
}

.apexchart {
    min-width: 100%;
}

.card_dashboard {
    background-color: WHITE;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.05);
    border-radius: 20px;
}

.red-color {
    color: RED;
}

.orange-color {
    color: #FF7B00;
}

.gray-color {
    color: rgb(102, 102, 102);
}

.green-color {
    color: GREEN;
}

.light-green-color {
    color: #28C868;
}

</style>
